import store from "../store";
import Constants from "../config/constants";
import { serviceGetPreOnboardingList } from "../services/PreOnboardingDocumentsApproval.service";

export const FETCH_INIT = "FETCH_INIT_PRE_ONBOARDING";
export const FETCHED = "FETCHED_PRE_ONBOARDING";
export const FETCHED_FAIL = "FETCHED_FAIL_PRE_ONBOARDING";
export const FETCHED_FILTER = "FETCHED_FILTER_PRE_ONBOARDING";
export const FETCH_NEXT = "FETCH_NEXT_PRE_ONBOARDING";
export const FILTER = "FILTER_PRE_ONBOARDING";
export const RESET_FILTER = "RESET_FILTER_PRE_ONBOARDING";
export const SET_SORTING = "SET_SORTING_PRE_ONBOARDING";
export const SET_FILTER = "SET_FILTER_PRE_ONBOARDING";
export const SET_PAGE = "SET_PAGE_PRE_ONBOARDING";
export const CHANGE_PAGE = "CHANGE_PAGE_PRE_ONBOARDING";
export const CHANGE_STATUS = "CHANGE_STATE_PRE_ONBOARDING";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_PRE_ONBOARDING";
export const CREATE_DATA = "CREATE_PRE_ONBOARDING";
export const UPDATE_DATA = "UPDATE_PRE_ONBOARDING";
export const DELETE_ITEM = "DELETE_PRE_ONBOARDING";

export function actionFetchPreOnboardingList(index = 1, sorting = {}, filter = {}, options = {}) {
  const request = serviceGetPreOnboardingList({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index, ...options } });
        if (!options.preservePage) { dispatch({ type: SET_SERVER_PAGE, payload: index }); }
        if (index == 1 && !options.preservePage) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}


export function actionSetPagePreOnboardingList(page) {
  const stateData = store.getState().pre_onboarding;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;
  
  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchPreOnboardingList(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
